import { adminApi, publicApi } from './http';

export const fetchPublicMenus = () => publicApi.get('/site-menus');

export const fetchAdminMenus = () => adminApi.get('/site-menus');

export const createAdminMenu = (payload) => adminApi.post('/site-menus', payload);

export const updateAdminMenu = (id, payload) => adminApi.put(`/site-menus/${id}`, payload);

export const deleteAdminMenu = (id) => adminApi.delete(`/site-menus/${id}`);
